import { render, staticRenderFns } from "./CardWebChat.vue?vue&type=template&id=169a2664&scoped=true&"
import script from "./CardWebChat.vue?vue&type=script&lang=js&"
export * from "./CardWebChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169a2664",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('169a2664')) {
      api.createRecord('169a2664', component.options)
    } else {
      api.reload('169a2664', component.options)
    }
    module.hot.accept("./CardWebChat.vue?vue&type=template&id=169a2664&scoped=true&", function () {
      api.rerender('169a2664', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/accountdashboard/CardWebChat.vue"
export default component.exports